<div class="top-navigation">
  <div class="content">
    <!-- Logo Section -->
    <div class="logo-section">
      <div class="logo-brand" (click)="handleLogoClick()">
        <span class="brand-name">Deloitte Ascend&#8482;</span>
      </div>
      <div class="logo-separator">
        <div class="separator-line"></div>
      </div>
      <div class="logo-product" (click)="handleLogoClick()">
        <span class="product-name">Test AI</span>
      </div>
    </div>

    <!-- Main Navigation (Center Pills) -->
    <div class="main-navigation">
      <div class="pill-container">
        @for (link of navlinks; track link.label; let i = $index) {
          <a class="navpill"
            [routerLink]="link.path"
            routerLinkActive="navpill--active"
            #rla="routerLinkActive"
            [hasAccess]="[FEATURES.menu, link.label]"
            (click)="handleClick(link, i)">
            <span class="navpill__content">
              <img class="navpill__icon"
                [src]="'assets/images/icons/' + link.icon + (rla.isActive ? '_inlined' : '') + '.svg'"
                [alt]="link.label" />
              <span class="navpill__label">{{link.label}}</span>
            </span>
          </a>
        }
      </div>
    </div>

    <!-- Right Actions -->
    <div class="right-actions">
      <!-- Help Button -->
      <button class="action-btn help-btn"
        [matMenuTriggerFor]="helpMenu"
        aria-label="Help menu"
        (click)="arrowRotate()"
        (menuOpened)="arrowIsRotatedUp"
        (menuClosed)="arrowReset()">
         <img src="assets/images/help.svg" alt="" /></button>
      <mat-menu #helpMenu="matMenu" class="help-menu-panel">
        <button mat-menu-item (click)="askMe()">Ask Me</button>
        <button mat-menu-item (click)="userGuide()">User Guide</button>
        <button mat-menu-item (click)="trainingCourse()">Training Course</button>
        <button mat-menu-item (click)="requestDemo()">Request Demo</button>
        <button mat-menu-item (click)="serviceRequest()">Raise a Service Request</button>
        @if(utilityVersions?.length) {
          <button mat-menu-item [matMenuTriggerFor]="recorderMenu">Test AI Recorder</button>
        }
      </mat-menu>
      <mat-menu #recorderMenu="matMenu" class="help-menu-panel">
        @if(utilityVersions?.[0]) {
          <button class="d-flex justify-content-between" mat-menu-item
            (click)="downloadUtility(utilityVersions[0]?.version)">
            <span>Download (v {{ utilityVersions[0]?.version }})</span>
            <span class="older-label">{{ utilityVersions[0]?.date }}</span>
          </button>
        }
        @if(utilityVersions?.length > 1) {
          <mat-divider></mat-divider>
          <div class="older-label">Older versions:</div>
          <button class="d-flex justify-content-between" *ngFor="let version of utilityVersions.slice(1)"
            mat-menu-item
            (click)="downloadUtility(version?.version)">
            <span>Download (v {{ version?.version }})</span>
            <span class="older-label">{{version?.date}}</span>
          </button>
        }
      </mat-menu>

      <!-- User Avatar -->
      <button class="user-avatar" [matMenuTriggerFor]="userMenu">
        <span class="user-avatar__initials">{{userInitials}}</span>
      </button>
      <mat-menu #userMenu="matMenu" class="nav-bar-menu-panel">
        <ng-template matMenuContent>
          <div class="profile-section">
            <div class="profile-gradient"></div>
            <div class="profile-info">
              <div class="profile-avatar">
                <span class="profile-avatar__initials">{{userInitials}}</span>
              </div>
              <div class="profile-name-designation">
                <span class="profile-name">{{userDetails?.name}}</span>
                <span class="profile-designation">{{userDetails?.email}}</span>
              </div>
            </div>
          </div>
          <div class="menu-container">
            <div class="menu-items">
              <button mat-menu-item class="menu-item" (click)="cookies()">
                <img src="assets/images/cookies.svg" alt="" />                <span class="menu-item__label">Cookies</span>

</button>
              <button mat-menu-item class="menu-item" (click)="cookieSettings()">
                <img src="assets/images/cookies_settings.svg" alt="" />
                <span class="menu-item__label">Cookie Settings</span>
              </button>
              <button mat-menu-item class="menu-item" (click)="navigateToLicenses()">
                <img src="assets/images/licenses.svg" alt="" />              
                <span class="menu-item__label">Licenses</span>
              </button>
              @if(isGenAIEnabled){
                <button mat-menu-item class="menu-item" (click)="disclaimer()">
                <img src="assets/images/termsofuse.svg" alt="" />             
                  <span class="menu-item__label">Terms of Use</span>
                </button>
              }
              <button mat-menu-item class="menu-item" (click)="navigateToPrivacy()">
                <img src="assets/images/privacy.svg" alt="" />
                <span class="menu-item__label">Privacy</span>
              </button>
            </div>
            <div class="menu-divider"></div>
            <button mat-menu-item class="menu-item menu-item--logout" (click)="logOut()">
             <img src="assets/images/logout.svg" alt="" />              
              <span class="menu-item__label">Logout</span>
            </button>
          </div>
        </ng-template>
      </mat-menu>
    </div>
  </div>
</div>